import { Card, makeStyles, tokens, Tooltip } from "@fluentui/react-components";
import { LinkMultipleFilled } from "@fluentui/react-icons";
import { t } from "i18next";
import { Fragment } from "react/jsx-runtime";
import { Activity } from "../../models/Activity";
import {
  getProcessPathsOfActivity,
  getProcessTagsOfActivity,
} from "../../services/ActivityService";
import { getClientAppNavUrl } from "../../services/EndUserClientService";

type Props = { activity?: Activity | undefined };

const useClasses = makeStyles({
  infoCard: {
    marginTop: tokens.spacingVerticalL,
  },
  mirroredChildrenHeader: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  pathsList: {
    margin: 0,
    padding: 0,
    listStyle: "none",
  },
  pathsListItem: {
    padding: tokens.spacingVerticalS,
  },
  mirroredLinksContainer: {
    display: "flex",
  },
  mirrorIconWrapper: {
    borderRight: "2px solid #ddd",
    paddingRight: "5px",
    display: "flex",
  },
  mirrorIconExtraBorders: {
    borderTop: "2px solid #ddd",
    borderBottom: "2px solid #ddd",
    width: "10px",
    marginRight: "-7px",
  },
  mirrorIcon: {
    margin: "auto",
  },
});

export const MirroredAndSharedInfoCard = (props: Props) => {
  const classes = useClasses();

  const { activity: activity } = props;

  function renderMirroredActivityPaths(mirroredActivity: Activity) {
    const tags = getProcessTagsOfActivity(mirroredActivity);

    return (
      <div className={classes.mirroredLinksContainer}>
        {tags.length > 1 && (
          <>
            <div className={classes.mirrorIconWrapper}>
              <Tooltip
                content={t("mirroredActivitySharedTooltip")}
                relationship="label"
              >
                <LinkMultipleFilled className={classes.mirrorIcon} />
              </Tooltip>
            </div>
            <div className={classes.mirrorIconExtraBorders}></div>
          </>
        )}
        <ul className={classes.pathsList}>
          {tags.map((tag) => (
            <li key={tag.id}>
              <a
                href={getClientAppNavUrl(tag.id)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {tag.path}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  if (!activity) {
    return null;
  }

  if (
    getProcessPathsOfActivity(activity).length === 0 &&
    (!activity?.mirroredChildren || activity.mirroredChildren.length === 0)
  ) {
    return null;
  }

  return (
    <Card className={classes.infoCard}>
      <div className={classes.mirroredChildrenHeader}>
        <strong>{t("sharedActivityChaptersList")}</strong>
      </div>
      <ul className={classes.pathsList}>
        {getProcessPathsOfActivity(activity).map((path, index) => (
          <li key={index}>{path}</li>
        ))}
      </ul>
      {activity?.mirroredChildren && activity.mirroredChildren.length > 0 && (
        <>
          <div className={classes.mirroredChildrenHeader}>
            <strong>
              {t("mirrorChildrenList", {
                mirroredChildrenCount: activity.mirroredChildren.length,
              })}
            </strong>
          </div>

          <div>
            {activity.mirroredChildren.map((mirroredChild) => (
              <Fragment key={mirroredChild.id}>
                {renderMirroredActivityPaths(mirroredChild)}
              </Fragment>
            ))}
          </div>
        </>
      )}
    </Card>
  );
};
